import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';

// 第一層
const ShopSetting = new PrimaryMenuItem('ShopSetting', 'build');

// 第二層
const CloudShopManagementSetting = new SecondaryMenuItem('CloudShopManagementSetting', () => import('@/modules/cloudshop/views/CloudShop.vue'));

// 註冊第二層
ShopSetting.RegisterChild(CloudShopManagementSetting);

export default ShopSetting;
